import React from 'react';
import ReactDOM from 'react-dom/client';

import App from 'src/App';
import { version } from '../package.json';

document.documentElement.dataset.werxpaceVersion = version;
console.info(`WerxPace landing v${version}`);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
